import { Shape } from './index.js';

export class Rect extends Shape {
	draw(context) {
		const { top, right, bottom, left } = this.radius;
		const { width, height } = this.size;
		const { x, y } = this.position;

		// Save the current canvas state
		context.save();
		context.translate(x, y);
		context.rotate(this.rotation * Math.PI / 180);

		// Apply fill and shadow styles
		this.applyStyles(context);

		// Begin drawing the path for the rounded rectangle
		context.beginPath();
		context.moveTo(left, 0);
		context.arcTo(0, 0, 0, top, top); // Top-left
		context.lineTo(0, height - right);
		context.arcTo(0, height, right, height, right); // Bottom-left
		context.lineTo(width - bottom, height);
		context.arcTo(width, height, width, height - bottom, bottom); // Bottom-right
		context.lineTo(width, top);
		context.arcTo(width, 0, width - left, 0, left); // Top-right
		context.closePath();

		// Clip before drawing anything inside
		context.clip();

		// Fill the rectangle
		context.fill();

		// Apply stroke if defined
		Object.keys(this.stroke).forEach(side => {
			const strokeSide = this.stroke[side];
			if (strokeSide.size > 0) {
				context.lineWidth = strokeSide.size;
				context.strokeStyle = strokeSide.color;
				context.stroke(); // Apply stroke after clipping
			}
		})
		this.beforeRestore(context)
		// Restore the canvas state to its original state
		context.restore();
	}

}
